<template>
  <StaffOrderDialog
    v-if="env.mode === 'STAFF'"
    title="Add Guest Privileges"
    :person-id="person?.personId"
    :item-type="ItemType.GUEST_PRIVS"
    :membership-id="existingMembershipId"
    @complete="membershipDataState?.update(true)"
  />
  <ShopDialog
    v-else
    title="Add Guest Privileges"
    :item-type="ItemType.GUEST_PRIVS"
    :membership-id="props.existingMembershipId"
    @complete="membershipDataState?.update(true)"
  />
</template>

<script lang="ts" setup>
import { useEnv } from "@/composables/useEnv";
import type { DirtyFlag } from "@/composables/useDirtyFlag";
import { ItemType } from "../../../cbi-generator/generated/dto/ItemType";
import type { PersonStaff as Person } from "../../../cbi-generator/generated/dto/PersonStaff";
const env = useEnv();
const membershipDataState = inject<DirtyFlag | undefined>(
  "membershipDataState",
);

const props = defineProps<{
  existingMembershipId?: number;
}>();

const person = inject<Ref<Person | null>>("person");
</script>
